module.exports = __webpack_public_path__ + "img/D0016.9882259b.svg";